import {
  SHOPIFY_SALES_REFERRER_SUCCESS,
  SHOPIFY_SALES_REFERRER_LOADING,
  } from '../actions/SalesByReferrerAction';
  
  const initialState = {
    SalesByReffererData: [],
    isLoading: true
  };
  
  const SalesByReferrerReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case SHOPIFY_SALES_REFERRER_SUCCESS:
        return { ...state, SalesByReffererData: action.data, isLoading: false };
      case SHOPIFY_SALES_REFERRER_LOADING:
        return { ...state, isLoading: action.isLoading };
      default:
        return state;
    }
  };
  
  export default SalesByReferrerReducer;
  